// Phase 2.3 Lite — Compact status pill for any link row. Pure presentation.

import React from 'react';

const TONES = {
  internal:           'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300',
  live:               'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-200',
  disabled:           'bg-gray-200 text-gray-700 dark:bg-gray-800 dark:text-gray-300',
  private:            'bg-indigo-100 text-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-200',
  draft:              'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-200',
  sent_for_review:    'bg-sky-100 text-sky-800 dark:bg-sky-900/30 dark:text-sky-200',
  approved:           'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-200',
  changes_requested:  'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-200',
};

const LABELS = {
  internal:           'Internal',
  live:               'Live',
  disabled:           'Disabled',
  private:            'Private',
  draft:              'Draft',
  sent_for_review:    'Sent for review',
  approved:           'Approved',
  changes_requested:  'Changes requested',
};

export default function LinkStatusBadge({ status, testid }) {
  if (!status) return null;
  const tone = TONES[status] || TONES.disabled;
  const label = LABELS[status] || status;
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] uppercase tracking-wider font-medium ${tone}`}
      data-testid={testid || `link-status-badge-${status}`}
    >
      {label}
    </span>
  );
}
